export default "__VITE_ASSET__CEGkpVm7__"